/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum Pm2WorkerTaskType {
    Pm2List = 1,
    Pm2Stop = 2,
    Pm2Start = 3,
    Pm2Restart = 4,
    Pm2Reset = 5,
    Pm2Log = 6,
    Pm2Delete = 7,
}